"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _CustomIconOrImage = _interopRequireDefault(require("./shared/CustomIconOrImage"));
var _DynamicStepper = _interopRequireDefault(require("./DynamicStepper/DynamicStepper"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalStepper = _interopRequireDefault(require("./VerticalStepper"));
var _services = require("../services");
var _useAppSelector = require("../hooks/useAppSelector");
var _uiSelectors = require("../store/ui/uiSelectors");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ModalWrapper = _styledComponents.default.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  & div[class*='GridRowstyle__GridRow'] {
    min-width: 100%;
    @media (min-width: 768px) {
      & > div {
        width: 100%;
      }
    }
  }
`;
const StyleLeftColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-right: 10px;
  padding-left: 10px;
`;
const LargeModalWrapper = _styledComponents.default.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: ${prop => prop.padding};
`;
const ImageWrapper = _styledComponents.default.div`
  display: block;
  position: relative;
  align-self: center;
  bottom: 0;
`;
const StyledBackgroundMobile = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  background-color: rgb(71 0 0 / 50%) !important;
  margin-top: -49%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 80vh;
  position: relative;
`;
const StyleComponent = _styledComponents.default.div`
  padding: 10px 16px 22px;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  #question-footer {
    margin-top: auto;
  }
`;
const StyledContainer = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  margin-bottom: 5px;
  height: 100%;
  z-index: 2;
  position: relative;
`;
const StyledBackground = _styledComponents.default.div`
  background-color: rgb(71 0 0 / 50%) !important;
  margin-bottom: 20px;
  padding: 15px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 96%;
`;
const ContentWrapper = _styledComponents.default.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  #question-footer {
    margin-top: auto;
  }
`;
const SmallModalWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  flex-direction: column;
  & img {
    margin-top: -90px;
    width: revert-layer;
    height: auto;
  }
`;
const StyledStepper = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  display: flex;
  flex-direction: column;
  margin: 2px;
  #vertical-stepper-title {
    font-size: 24px;
    line-height: 30px;
  }
`;
const StyledStepperMobile = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  padding-top: 20px;
  justify-content: center;
  margin-bottom: 15px;
`;
const StyledImage = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  flex-shrink: 0;
  display: block;
  position: absolute;
  bottom: 0;
  width: max-content;
  z-index: 1;
`;
const GermanyBroadbandBody = _ref => {
  let {
    children,
    configRecommendationIcons
  } = _ref;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const questionIcons = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectIcons);
  const icons = currentPage === _constants.PAGES.RECOMMENDATION ? configRecommendationIcons : questionIcons;
  const largeModalPadding = currentPage === _constants.PAGES.ERROR ? '0 20px 0' : '0 30px 0';
  return /*#__PURE__*/_react.default.createElement(ModalWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'between'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(LargeModalWrapper, {
    padding: largeModalPadding
  }, /*#__PURE__*/_react.default.createElement(StyleLeftColumn, {
    col: 4
  }, /*#__PURE__*/_react.default.createElement(StyledStepper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    id: "vertical-stepper-title"
  }, _services.Services.locale.localeString('VerticalStepper.title')), /*#__PURE__*/_react.default.createElement(_VerticalStepper.default, null)), /*#__PURE__*/_react.default.createElement(StyledImage, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: {
      xl: icons === null || icons === void 0 ? void 0 : icons.large,
      lg: icons === null || icons === void 0 ? void 0 : icons.large,
      md: icons === null || icons === void 0 ? void 0 : icons.large,
      alt: ''
    },
    iconWidth: "390px",
    iconHeight: "226px"
  }))), /*#__PURE__*/_react.default.createElement(StyledContainer, {
    col: 8
  }, /*#__PURE__*/_react.default.createElement(StyledBackground, null, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, children))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(SmallModalWrapper, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: {
      sm: icons === null || icons === void 0 ? void 0 : icons.small,
      alt: ''
    },
    iconWidth: "450px",
    iconHeight: "450px"
  })), /*#__PURE__*/_react.default.createElement(StyledBackgroundMobile, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(StyledStepperMobile, {
    col: 10
  }, /*#__PURE__*/_react.default.createElement(_DynamicStepper.default, null)), /*#__PURE__*/_react.default.createElement(StyleComponent, null, children))))))));
};
var _default = GermanyBroadbandBody;
exports.default = _default;